import { useState, useCallback } from 'react';
import { calculateTravelFee } from '../api/publicBookingApi';

const useTravelFeeCalculation = (slug) => {
  const [travelFee, setTravelFee] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const calculateFee = useCallback(async (customerAddress) => {
    if (!customerAddress || !slug) {
      setTravelFee(null);
      setError(null);
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const result = await calculateTravelFee(slug, customerAddress);
      setTravelFee(result.travelFee);
    } catch (err) {
      setError(err.message);
      setTravelFee(null);
    } finally {
      setIsLoading(false);
    }
  }, [slug]);

  const resetFee = useCallback(() => {
    setTravelFee(null);
    setError(null);
    setIsLoading(false);
  }, []);

  return {
    travelFee,
    isLoading,
    error,
    calculateFee,
    resetFee
  };
};

export default useTravelFeeCalculation;